<script>
import pagination from "laravel-vue-pagination";
import config from "../../config";
import { driverService } from '../../services';
import moment from "moment";

export default {
    components: { pagination},
    data() {
        return {
            loading: false,
            sortBy: "order_id",
            sortDesc: true,
            ratings:[],
            ratingData:[],
            paginations:{},
            limit:1,
            search:'',
            status:1,
            config:config,
            moment:moment,
            fields: [
                { key: 'order_id',label: this.trans.get('__JSON__.Order Id'), sortable: true },
                // { key: 'user_id',label: this.trans.get('__JSON__.Customer Id'), sortable: true },
                // { key: 'user_name',label: this.trans.get('__JSON__.Customer Name'), sortable: true },
                // { key: 'mobile_number',label: this.trans.get('__JSON__.Mobile Number'), sortable: true },
                { key: 'ratings',label: this.trans.get('__JSON__.Rating'), sortable: true },
                { key: 'message',label: this.trans.get('__JSON__.Review'), sortable: true },
                { key: 'created_at',label: this.trans.get('__JSON__.Date'), sortable: true },
            ]
        };
    },
    mounted() {
        this.getDriverRating();
    },
    methods:{
        getDriverRating(page){
            this.loading = true;
            driverService.getDriverRating({
                search: this.search,
                status: this.status,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? 'desc':'asc',
                page: page?page:1,
                driver_id: this.$route.params.driver_id
            })
            .then(response => {
                this.loading = false;
                this.paginations = response.data.result;
                this.ratings = response.data.result.data;
            }).catch(()=>{
                this.loading = false;
            });
        },
        searchData() {
            this.getDriverRating();     
        },
        sortingChanged(ctx){
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getDriverRating();
        }
    }
};
</script>

<template>
   <div class="row">
      <div class="col-12 list-table-main">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-2 offset-sm-10">
                        <div class="search-box mb-3 d-inline-block">
                            <div class="date-range-list">
                            <label>{{ trans.get('__JSON__.Search') }} :</label>
                            <div class="position-relative">
                                <input
                                type="text"
                                class="form-control"
                                @keyup="searchData()"
                                v-model="search"
                                :placeholder="trans.get('__JSON__.Search...')"
                                />
                                <i class="bx bx-search-alt search-icon"></i>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 table-main-list table-responsive">
                    <b-table
                        :items="ratings"
                        :fields="fields"
                        :sort-by.sync="sortBy"
                        :no-local-sorting="true"
                        @sort-changed="sortingChanged"
                        show-empty
                        :busy="loading"
                    >
                        <!-- <template v-slot:cell(user_id)="data">
                           <h5 class="font-size-14">{{ data.item.user_id}}</h5>  
                        </template> -->
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>{{ trans.get("__JSON__.Loading...") }}</strong>
                            </div>
                        </template>
                        <template v-slot:cell(ratings)="data">
                            <div v-if="data.item.ratings <= 2">
                                <span class="badge badge-danger font-size-12">
                                    <i class="mdi mdi-star mr-1"></i>
                                    {{parseFloat(data.item.ratings).toFixed(2)}}
                                </span>
                                </div>
                                <div v-else>
                                    <span class="badge badge-success font-size-12">
                                    <i class="mdi mdi-star mr-1"></i>
                                    {{parseFloat(data.item.ratings).toFixed(2)}}
                                </span>
                            </div>
                        </template>

                        <template v-slot:cell(message)="data">
                             <div v-if="data.item.message">
                                <div
                                    v-if="data.item.message.length > 140"
                                >{{data.item.message.substr(0, 140)+ '...'}}</div>
                                <div v-else>{{data.item.message}}</div>
                                </div>
                                <div v-else class="mt-3">
                                <p>{{ trans.get('__JSON__.Description not added by user') }}</p>
                             </div>
                        </template>

                        <template v-slot:cell(created_at)="data">
                            <div v-if="data.item.created_at">
                                {{moment(data.item.created_at).format('D MMM,Y')}}
                            </div>
                        </template>

                        <template #empty>
                          <p class="text-center">{{ trans.get('__JSON__.No Rating') }}</p>
                        </template>

                    </b-table>  
                </div>
                <div class="row col-sm-5 offset-sm-7">
                    <div class="col">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <!-- pagination -->
                            <pagination :data="paginations" :limit="limit" @pagination-change-page="getDriverRating"></pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  <!-- end table -->
</template>
